export enum StoresModalContext {
  default = "default",
  pickUpStores = "pickUpStores",
}
